import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb418d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "card-header-1" }, [
    /*#__PURE__*/_createTextVNode(" Crypto education "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" for the modern "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" financial advisor ")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-body-1" }, " Onramp Academy provides industry-leading market research, resources on foundational crypto knowledge, and powerful tools specially designed to help financial advisors navigate the emerging crypto economy. ")
], -1))
const _hoisted_3 = { class: "card-footer-1" }
const _hoisted_4 = { class: "pt-2 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    width: '100%',
    "background-color": 'transparent'
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            text: 'Learn More',
            onButtonClick: _ctx.goToAcademyTab
          }, null, 8, ["onButtonClick"])
        ])
      ])
    ]),
    _: 1
  }))
}